import { render, staticRenderFns } from "./RouteMap.vue?vue&type=template&id=58a5693a&scoped=true"
import script from "./RouteMap.vue?vue&type=script&lang=js"
export * from "./RouteMap.vue?vue&type=script&lang=js"
import style0 from "./RouteMap.vue?vue&type=style&index=0&id=58a5693a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5693a",
  null
  
)

export default component.exports